import { ArticleCardProps } from 'components/BaseHelpers/ArticleCard';
import ArticleGrid from 'components/BaseHelpers/ArticleGrid/ArticleGrid';

import styles from './ResultsListing.module.scss';

export type ResultsListingProps = {
  items: ArticleCardProps[];
  pinnedItems: ArticleCardProps[];
  shouldShowPinnedItems: boolean;
  resultsToShow: number;
};

const ResultsListing = (props: ResultsListingProps): JSX.Element => {
  const {
    items,
    pinnedItems: featuredItems,
    shouldShowPinnedItems: shouldShowFeaturedItems,
    resultsToShow,
  } = props;

  const featuredItemsId = new Set(featuredItems.map((item) => item.id));
  const nonFeaturedItems = items.filter((item) => !featuredItemsId.has(item.id));

  const itemsToDisplay = shouldShowFeaturedItems ? [...featuredItems, ...nonFeaturedItems] : items;
  const hasAnyItems = itemsToDisplay.length > 0;
  const itemsForCurrentPage = itemsToDisplay.slice(0, resultsToShow);

  if (!hasAnyItems) {
    return <></>;
  }

  return <ArticleGrid className={styles.main} items={itemsForCurrentPage} />;
};

export default ResultsListing;
